import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import SponsorshipModel from "../../models/SponsorshipModel";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexSponsorships(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});

  return Axios.get("v1/liaisons/sponsorships", { params });
}
